export default __webpack_public_path__ + "static/logo-lockup-51c8dbe7e8c9a0afdd9dee9aaec7dd45.png";